// extracted by css-extract-rspack-plugin
export default {"icon":"_9e73dfe5","itemLink":"_41f8621b","disabledItemLink":"_64b4bd6b"};